import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/startWith';
import {Subscription} from 'rxjs/Subscription';


interface ScrollPosition {
    sH: number;
    sT: number;
    cH: number;
};

const DEFAULT_SCROLL_POSITION: ScrollPosition = {
    sH: 0,
    sT: 0,
    cH: 0
};

@Directive({
    selector: '[scrollable]'
})
export class ScrollableDirective implements AfterViewInit, OnDestroy {

    private scrollEvent$;

    private userScrolledDown$;

    public subscriptions: Subscription[] = [];

    private requestOnScroll$;

    @Input()
    scrollCallback;

    @Input()
    immediateCallback;

    @Input()
    scrollPercent = 70;

    constructor(private elm: ElementRef) { }

    ngAfterViewInit() {
        this.registerScrollEvent();
        this.streamScrollEvents();
        this.requestCallbackOnScroll();

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    private registerScrollEvent() {
        this.scrollEvent$ = Observable.fromEvent(this.elm.nativeElement, 'scroll');
    }

    private streamScrollEvents() {
        this.userScrolledDown$ = this.scrollEvent$
            .map((e: any): ScrollPosition => ({
                sH: e.target.scrollHeight,
                sT: e.target.scrollTop,
                cH: e.target.clientHeight
            }))
            .pairwise()
            .filter(positions => this.isUserScrollingDown(positions) && this.isScrollExpectedPercent(positions[1]));
    }

    private requestCallbackOnScroll() {
        this.requestOnScroll$ = this.userScrolledDown$;

        if (this.immediateCallback) {
            this.requestOnScroll$ = this.requestOnScroll$
                .startWith([DEFAULT_SCROLL_POSITION, DEFAULT_SCROLL_POSITION]);
        }

        const scrollSub = this.requestOnScroll$
            .exhaustMap(() => {
                return this.scrollCallback();
            })
            .subscribe((data) => { console.log(data); }, (err) => console.log(err));
        this.subscriptions.push(scrollSub);
    }

    private isUserScrollingDown = (positions) => {
        return positions[0].sT < positions[1].sT;
    }

    private isScrollExpectedPercent = (position) => {
        return ((position.sT + position.cH) / position.sH) > (this.scrollPercent / 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/directives/scrollable.directive.ts